import { createSelector } from 'reselect'
import * as R from 'ramda'

const riskStateSelector = state => state.riskValidation

const getFirstFalseId = R.compose(
  R.prop(0),
  R.find(R.propEq(1, false)),
  R.toPairs
)

const invalidElementIdSelector = createSelector(
  riskStateSelector,
  getFirstFalseId
)

const riskCountSelector = createSelector(
  riskStateSelector,
  R.compose(
    R.prop('length'),
    R.keys
  )
)

const riskSelector = createSelector(
  invalidElementIdSelector,
  R.compose(
    R.not,
    R.isNil
  )
)

const showRiskSelector = id => createSelector(
  riskStateSelector,
  (ids) => R.not(ids[id])
)

export {
  invalidElementIdSelector,
  riskCountSelector,
  riskStateSelector,
  riskSelector,
  showRiskSelector
}
